<template>
  <v-dialog v-model="dialog" persistent width="780px">
    <v-card>
      <v-card-title class="headline">
        <v-icon>check</v-icon>Aprobar permiso
        <v-spacer></v-spacer>
        <v-btn icon @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-0">
        <v-container grid-list-md class="pt-0">
            <v-layout row wrap>
						
						<v-flex xs12>
							<h3><strong>Número:</strong>   {{permiso.numero }}</h3>
						</v-flex>
						<v-flex xs12>
							<h3><strong>Funcionario:</strong>   {{ permiso.nombres }}</h3>
						</v-flex>
					<v-flex xs12>
							<h3><strong>Tipo de papeleta:</strong>   {{ permiso.tipo_permiso }}</h3>
						</v-flex >
						<v-flex xs12 v-if="permiso.id_tipo_permiso == 8">
							<h3><strong>Lugar de atencion:</strong>   {{ permiso.lugar_atencion }}</h3>
						</v-flex >
							<v-flex xs12 v-if="permiso.id_tipo_permiso == 87">
							<h3><strong>Lugar de comisión  :</strong>   {{ permiso.permiso.lugar }}</h3>
						</v-flex>
						<v-flex xs12  v-if="permiso.id_tipo_permiso == 87 || permiso.id_tipo_permiso == 96">
							<h3><strong>Motivo:</strong> {{ permiso.permiso.motivo }}</h3>
						</v-flex>
						<v-flex xs12  v-if="permiso.id_tipo_permiso == 90">
							<h3><strong>Tipo de baja:</strong> {{ permiso.permiso.motivo }}</h3>
						</v-flex>
					
					</v-layout>	
              <v-layout row wrap>
            <v-flex xs12>
              <h3><strong>Detalles de papeleta</strong></h3>
            </v-flex>

            <v-layout>
              <v-flex xs12>
                  <v-data-table
									:items="permiso_detalles2"
									class="elevation-1"
									hide-actions
									:headers="headers"
									  v-if="permiso.id_tipo_permiso != '24'"
									>
									<template v-slot:items="props">
										<td class="text-xs-center"
									  v-if="permiso.id_tipo_permiso != '24'"
										>
										{{ props.item.fecha_salida}}
										</td>
										<td class="text-xs-center"
										v-if="permiso.id_tipo_permiso != '24'"
										>
										{{ props.item.fecha_hasta}}
										</td>
									
										<td class="text-xs-center">{{ props.item.hora_desde }}</td>
										<td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                        <td class="text-xs-center"> {{ $moment(props.item.total_horas,'HH:mm').format('HH:mm') }}</td>
										 <td class="text-xs-center" >{{props.item.total_dias}}</td>
									    <td v-if="permiso.id_tipo_permiso==24" class="text-xs-center">{{ props.item.total_dias }}</td>

									</template>
                </v-data-table>
              </v-flex>
            </v-layout>
            <v-layout class="pa-2">
              <v-spacer></v-spacer>
              <!-- <v-flex xs3>
                <h4>
                  <strong
                    >Total horas: {{ horas_solicitadas.toFixed(2) }}</strong
                  >
                </h4>
              </v-flex> -->
            </v-layout>
          </v-layout>
          <!-- <v-layout class="text-xs-center">
            <v-flex xs2>
              <h4>Motivo:</h4>
            </v-flex>
            <v-flex xs10>
              <v-textarea
                color="gray"
                box
                solo
                outline
                v-model="permiso.rechazo"
               
              ></v-textarea>
            </v-flex>
          </v-layout> -->

          <v-layout>
			  <v-flex xs12>
        <v-flex xs12>
              <h3><strong>Seguimiento :</strong></h3>
            </v-flex>   
			  <v-data-table
			:headers="headers_seg_detalle"
			:items="detalle_seguimiento"
			class="elevation-1">
			<template v-slot:items="props">
			<td class="text-xs-center">{{ $moment(props.item._created_at).format("DD/MM/YYYY HH:mm") }} </td>
			<td class="text-xs-center">{{ props.item.estado.descripcion }}</td>
			<td class="text-xs-center">{{ props.item.usuario?props.item.usuario.nombre_usuario:"" }}</td>
			</template>
			</v-data-table>

			  </v-flex>
		
		
		</v-layout>

        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secundary" @click.prevent="close()" :loading="loading"
          ><v-icon>check</v-icon>
          Cancelar
        </v-btn>
        <v-btn
          color="success"
          @click.prevent="apruebaRechazaPermiso(permiso, 7)"
          :loading="loading"
          ><v-icon>check</v-icon>
          Aprobar
        </v-btn>
        <!-- <v-btn color="error" @click.prevent="apruebaRechazaPermiso(permiso, 16)"
          ><v-icon>clear</v-icon>
          Rechazar
        </v-btn> -->
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate";
import SeguimientoDetalle from "../components/SeguimientoDetalle";

export default {
  components: {
    SeguimientoDetalle,
  },
  mixins: [validate],
  props: ["item"],
  async mounted() {
    this.$bus.$on("openDialogAprobarPermiso", (item) => {
      this.permiso = item;
       this.permiso_detalles2=[
			{fecha_salida:this.permiso.fecha_desde,
			fecha_hasta:this.permiso.fecha_retorno,
			hora_desde:this.permiso.hora_desde,
			hora_hasta:this.permiso.hora_hasta,
			total_horas:this.permiso.horas_permiso,
			total_dias:this.permiso.nro_dias
			}
		],
     this.getDetallePermiso(this.permiso.id_permiso);
	  this.getDetalleSeguimiemto(this.permiso.id_permiso);
      this.dialog = true;
    });
  },
  data() {
    return {
      dialog: false,
      permiso: {
        permiso: {
          motivo: "",
        },
      },
      permiso_detalles: [],
       permiso_detalles2: [],
	  detalle_seguimiento: [],
      loading: false,
      headers: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center",
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center",
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center",
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center",
        },
        {
          text: "Total Horas",
          sortable: false,
          align: "center",
        },
        {
          text: "Total Dias",
          sortable: false,
          align: "center",
        },
      ],
		headers_seg_detalle: [
		// { text: 'Número', sortable: false, align: 'center'},
		{ text: 'Fecha de registro', sortable: false, align: 'center' },
		{ text: 'Estado', sortable: false, align: 'center' },
		{ text: 'Usuario Registro', sortable: false, align: 'center' },
	],

      horas_solicitadas: 0,
    };
  },
  methods: {
    close() {
      this.dialog = false;
      this.permiso = {
        permiso: {
          motivo: "",
        },
      };
	  this.$bus.$emit("closeDialog");
    },
    aprobarRechazar(id_permiso, id_estado) {
      this.loading = true;
      this.$service
        .graphql({
          query: `
					query {
						apruebaControlPermiso(id_tipo_permiso: ${id_permiso}, id_estado: ${id_estado}, id_jefe: ${this.getUserId()}){
							mensaje
						}
					}
				`,
        })
        .then((response) => {
          if (response.apruebaControlPermiso.mensaje === "ok") {
            this.$message.success();
            this.$bus.$emit("closeDialog");
            this.close();
          } else {
            this.$message.error(response.apruebaControlPermiso.mensaje);
            this.close;
          }
        });
      this.loading = false;
    },
    sumar_horas(permiso_detalles) {
      let total = 0;
      //console.log("horas",permiso_detalles)
      // permiso_detalles.forEach((item) => {
      //   total +=
      //     });
          
          let hora1 = ("04:29:01").split(":"),
          hora2 = ("03:28:56").split(":"),
          t1 = new Date(),
          t2 = new Date();
          t1.setHours(hora1[0], hora1[1], hora1[2]);
          t2.setHours(hora2[0], hora2[1], hora2[2]);
 
        //Aquí hago la resta
        t1.setHours(t1.getHours() - t2.getHours(), t1.getMinutes() - t2.getMinutes(), t1.getSeconds() - t2.getSeconds());
				//console.log("La diferencia es de: " + (t1.getHours() ? t1.getHours() + (t1.getHours() > 1 ? " horas" : " hora") : "") + (t1.getMinutes() ? ", " + t1.getMinutes() + (t1.getMinutes() > 1 ? " minutos" : " minuto") : "") + (t1.getSeconds() ? (t1.getHours() || t1.getMinutes() ? " y " : "") + t1.getSeconds() + (t1.getSeconds() > 1 ? " segundos" : " segundo") : ""))
						
    
      this.horas_solicitadas = total;
    },
    getUserId() {
      const user = this.$storage.get("user");
      return user.id_persona;
    },
    async getDetallePermiso(id_permiso) {
      //console.log("id_per",id_permiso)
      try {
        let res = await this.$service.graphql({
          query: `
			query{
            vDetallePermisos(id_permiso: ${id_permiso}){
              rows{
                id
                id_permiso
                fecha_desde
                fecha_hasta
                hora_desde
                hora_hasta
                total_horas
                total_dias
              }
            }
          }
          `,
        });
        this.permiso_detalles = res.vDetallePermisos.rows;
        console.log("fffff",this.permiso_detalles)
        this.sumar_horas(this.permiso_detalles);
      } catch (error) {
        console.log(error);
      }
    },
    async getDetalleSeguimiemto(id) {
      try {
         let respuesta 
        let res 
        respuesta= await this.$service.graphql({
          query: `
                               query{
                                    runQuery(consulta:"SELECT * FROM control.v_seguimiento_detalle_historico vd where vd.id=(${id}) order by vd.id_seguimiento desc"){
                                  respuesta
                                }
                            }
                            `,
        });

        respuesta = respuesta.runQuery.respuesta;
        //obtener el nuevo seguimiento
         res = await this.$service.graphql({
          query: `
                query{
      			      vSeguimientoDetalles(id:${id}){
          			    rows{
						          fecha_registro
            			    estado
            			    usuario
                      jefe
                      id_estado
                      motivo
                      jefe
                      }
                  }
              }

          `,
        });
        res = res.vSeguimientoDetalles.rows;
        this.detalle_seguimiento = res.concat(respuesta);
      } catch (error) {
        console.log(error);
      }
    },
	async apruebaRechazaPermiso(permiso, id_estado){
    
		const user = this.$storage.get("user");
	
    //console.log(user.id_persona,user.id,permiso.id_permiso)
		let respuesta = "";
    //console.log("DDDDDDDDD",this.permiso.id_tipo_permiso)
    if(this.permiso.id_tipo_permiso==24){
           //console.log("rrrrr");
                            try {
                                    respuesta = await this.$service.graphql({
                                      query: `
                                        query{
                                          runQuery(consulta:"select control.fn_aprueba_cta_vacacion(${permiso.id_permiso},'${id_estado}','${user.id_persona}','${user.id}')"){
                                            respuesta
                                          }
                                        }
                                      `
                                    });
                                    //console.log(respuesta.runQuery.respuesta)
                                    let resp=respuesta.runQuery.respuesta[0].fn_aprueba_cta_vacacion

                                    let resps = resp.split('|');
                                    let correcto = resps[0]; 
                                    //console.log(correcto);
                                  if (correcto == '1') {
                                    this.$message.success()
                                   
                                   location.reload()
                                  } else {
                                    this.$message.error(resps )
                                    // this.close()
                                  }
                                  } catch (error) {
                                    console.log(error);
                                  }

              }

          
                           else{                 //console.log("rrrrr",permiso.permiso.motivo);
                                                                      try {
                                                                      respuesta = await this.$service.graphql({
                                                                        query: `
                                                                          query{
                                                                            runQuery(consulta:"select control.fn_aprueba_permiso(${permiso.id_permiso},'${id_estado}',${user.id_persona},'${user.id}')"){
                                                                              respuesta
                                                                            }
                                                                          }
                                                                        `
                                                                      });
                                                                      console.log(respuesta.runQuery.respuesta)
                                                                      let resp=respuesta.runQuery.respuesta[0].fn_aprueba_permiso

                                                                      let resps = resp.split('|');
                                                                      let correcto = resps[0]; 
                                                                      console.log(correcto);
                                                                    if (correcto == '1') {
                                                                      this.$message.success()
                                                                      //this.$router.push('/personas')
                                                                    // location.reload()
                                                                    } else {
                                                                      this.$message.error(resps )
                                                                      // this.close()
                                                                    }
                                                                    } catch (error) {
                                                                      console.log(error);
                                                                    }
                                                      }


		this.close();
	}
  },
};
</script>


// WEBPACK FOOTER //
// src/components/admin/permiso/dialogs/AprobarPermiso.vue